// Отбор видов в выборе раздела «Квоты»: по имени или по коду ВБР.
//
// Видов в году три-четыре десятка, и половину рыбак ищет по коду из донесения
// (400 — минтай), половину по слову. Код сравнивается НАЧАЛОМ («40» находит 400
// и 401), имя — вхождением без регистра и без «ё»: «ТРЕСК» и «треска» одно.

export interface SpeciesItem {
  code: number
  name: string
  tons: number
}

const norm = (s: string) => s.toLowerCase().replace(/\u0451/g, '\u0435').trim()

export function filterSpecies(list: readonly SpeciesItem[], query: string): SpeciesItem[] {
  const q = norm(query)
  if (!q) return [...list]
  return list.filter(s => (s.code > 0 && String(s.code).startsWith(q)) || norm(s.name).includes(q))
}

/** Длина полосы тоннажа: доля от крупнейшего вида списка, 0…1. Полоса от
 *  крупнейшего, а не от суммы: минтай держит 60 % тоннажа года, и в долях
 *  суммы все прочие виды сжались бы в точку. */
export function barShare(tons: number, list: readonly SpeciesItem[]): number {
  const max = list.reduce((m, s) => Math.max(m, s.tons), 0)
  return max > 0 ? Math.min(1, Math.max(0, tons / max)) : 0
}
